module.exports = __webpack_public_path__ + "img/gg-play.b3f78c07.svg";